export const SET_APP_LOCALE = 'SET_APP_LOCALE';

export type SetAppLocaleActionType = {
  type: typeof SET_APP_LOCALE;
  locale: string;
};
